import { extendTheme } from "@chakra-ui/react";

export default extendTheme({
    fonts: {
        heading: "Inter, sans-serif",
        body: "Inter, sans-serif",
        mono: "Inter, sans-serif",
    },
});
